"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stringifyObject = stringifyObject;
var _isObject = require("./isObject");
/**
 * This is just copied https://www.npmjs.com/package/stringify-object and slightly modified. All props to them.
 */ var propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
var toString = Object.prototype.toString;
function isRegexp(value) {
    return toString.call(value) === '[object RegExp]';
}
function getOwnEnumerableKeys(object) {
    return _to_consumable_array(Object.keys(object)).concat(_to_consumable_array(Object.getOwnPropertySymbols(object).filter(function(key) {
        return propertyIsEnumerable.call(object, key);
    })));
}
function stringifyObject(inputValue) {
    var leftPad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '', oneLineOnly = arguments.length > 2 ? arguments[2] : void 0;
    var seen = [];
    var indent = '   ';
    // eslint-disable-next-line complexity -- copied from other library
    return function stringify(input) {
        var pad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
        var tokens = {
            newline: oneLineOnly ? ' ' : '\n',
            newlineOrSpace: oneLineOnly ? ' ' : '\n',
            pad: pad,
            indent: oneLineOnly ? '' : pad + indent
        };
        if (seen.includes(input)) {
            return '"[Circular]"';
        }
        if (typeof input === 'function') {
            return '"[Function '.concat(input.name || 'anonymous', ']"');
        }
        if (typeof Buffer !== 'undefined' && input instanceof Buffer) {
            return '"[Buffer]"';
        }
        if (input === null || input === undefined || typeof input === 'number' || typeof input === 'boolean' || (typeof input === "undefined" ? "undefined" : _type_of(input)) === 'symbol' || isRegexp(input)) {
            return String(input);
        }
        if (input instanceof Date) {
            return "new Date('".concat(input.toISOString(), "')");
        }
        if (Array.isArray(input)) {
            if (input.length === 0) {
                return '[]';
            }
            seen.push(input);
            var returnValue = "[".concat(tokens.newline).concat(input.map(function(element, i, elements) {
                var eol = elements.length - 1 === i ? tokens.newline : ",".concat(tokens.newlineOrSpace);
                var value = stringify(element, pad + indent);
                return tokens.indent + value + eol;
            }).join('')).concat(tokens.pad, "]");
            seen.pop();
            return returnValue;
        }
        if ((0, _isObject.isObject)(input)) {
            var objectKeys = input instanceof Error ? Object.getOwnPropertyNames(input) : getOwnEnumerableKeys(input);
            if (objectKeys.length === 0) {
                return '{}';
            }
            seen.push(input);
            var returnValue1 = "{".concat(tokens.newline).concat(objectKeys.map(function(element, index) {
                var eol = objectKeys.length - 1 === index ? tokens.newline : ",".concat(tokens.newlineOrSpace);
                var isSymbol = (typeof element === "undefined" ? "undefined" : _type_of(element)) === 'symbol';
                var isClassic = !isSymbol && /^[a-z$_][$\w]*$/i.test(element);
                var key = isSymbol || isClassic ? element : stringify(element, undefined);
                var value = stringify(input[element], pad + indent);
                return "".concat(tokens.indent + String(key), ": ").concat(value).concat(eol);
            }).join('')).concat(tokens.pad, "}");
            seen.pop();
            return returnValue1;
        }
        var output = input.replace(/\\/g, '\\\\');
        output = String(output).replace(/[\r\n]/g, function(x) {
            return x === '\n' ? '\\n' : '\\r';
        });
        return '"'.concat(output.replace(/"/g, '\\"'), '"');
    }(inputValue, leftPad);
} //# sourceMappingURL=stringifyObject.js.map
